import type { VitaIndustryFieldFragment } from '@xingternal/crate-lebenslauf-graphql';

export const industries: VitaIndustryFieldFragment[] = [
  { id: '10000', label: 'Architektur und Bauwesen' },
  { id: '30000', label: 'Automobil und Fahrzeugbau' },
  { id: '120000', label: 'Banken und Finanzdienstleistungen' },
  { id: '160000', label: 'Beratung und Consulting' },
  { id: '60000', label: 'Energie, Wasser und Umwelt' },
  { id: '200000', label: 'Erziehung, Bildung und Wissenschaft' },
  { id: '210000', label: 'Gesundheit und Soziales' },
  { id: '140000', label: 'Immobilien' },
  { id: '40000', label: 'Industrie und Maschinenbau' },
  { id: '90000', label: 'Internet und Informationstechnologie' },
  { id: '20000', label: 'Konsumgüter und Handel' },
  { id: '220000', label: 'Kunst, Kultur und Sport' },
  { id: '170000', label: 'Marketing, PR und Design' },
  { id: '110000', label: 'Medien und Verlage' },
  { id: '180000', label: 'Personaldienstleistungen' },
  { id: '50000', label: 'Pharma und Medizintechnik' },
  { id: '230000', label: 'Sonstige Branchen' },
  { id: '100000', label: 'Telekommunikation' },
  { id: '80000', label: 'Tourismus und Gastronomie' },
  { id: '70000', label: 'Transport und Logistik' },
  { id: '130000', label: 'Versicherungen' },
  { id: '150000', label: 'Wirtschaftsprüfung, Steuern und Recht' },
  { id: '190000', label: 'Öffentlicher Dienst, Verbände und Einrichtungen' },
];
